export const cutDiscount = (price, discount) => {
  const discountedPrice = price - (price * (discount / 100))?.toFixed(2);
  return discountedPrice;
};
export const setToken = (accessToken, refreshToken) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};
export const getAccessToken = () => {
  return localStorage.getItem("accessToken");
};
export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};
export const getRefreshTokenAndEmail = () => {
  const res = {
    refreshToken: localStorage.getItem("refreshToken"),
    email: localStorage.getItem("email"),
  };
  return res;
};
export const removeAccessToken = () => {
  localStorage.removeItem("accessToken");
};
export const removeRefreshToken = () => {
  localStorage.removeItem("refreshToken");
};
export const clearLocalStorage = () => {
  removeAccessToken();
  localStorage.clear();
};

export const convertURLToFile = async (url) => {
  if (url) {
    const fileName = url.substring(url.lastIndexOf("/") + 1);
    const response = await fetch(url);
    const blob = await response.blob();
    const file = new File([blob], `${fileName}`, {
      type: blob.type,
    });
    file.imgSrc = url;
    return file;
  }
  return;
};
